"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireDefault(require("../../atoms/Image"));

var _MenuCartDisplayBanner = _interopRequireDefault(require("./components/MenuCartDisplayBanner"));

var _MenuCartDisplayItem = _interopRequireDefault(require("./components/MenuCartDisplayItem"));

var _MenuCartDisplayTotal = _interopRequireDefault(require("./components/MenuCartDisplayTotal"));

require("./MenuCartDisplay.css");

var _closed = _interopRequireDefault(require("./closed.svg"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var MenuCartDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuCartDisplay, _React$Component);

  var _super = _createSuper(MenuCartDisplay);

  function MenuCartDisplay(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuCartDisplay);
    _this = _super.call(this, props);
    _this.state = {
      mobileCartOpen: false
    };
    _this.toggleMobileCart = _this.toggleMobileCart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateItemTotal = _this.calculateItemTotal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateTotal = _this.calculateTotal.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuCartDisplay, [{
    key: "toggleMobileCart",
    value: function toggleMobileCart() {
      this.setState(function (_ref) {
        var mobileCartOpen = _ref.mobileCartOpen;
        return {
          mobileCartOpen: !mobileCartOpen
        };
      });
    }
  }, {
    key: "calculateItemTotal",
    value: function calculateItemTotal(item) {
      var selectedVariation = item.selectedVariation,
          selectedModifiers = item.selectedModifiers,
          quantity = item.quantity;
      var _selectedVariation$pr = selectedVariation.price,
          variationPrice = _selectedVariation$pr === void 0 ? 0.0 : _selectedVariation$pr;
      var modifierPrices = selectedModifiers.map(function (_ref2) {
        var price = _ref2.price;
        return price;
      });
      var modifiersTotal = modifierPrices.reduce(function (total, nextPrice) {
        return total + nextPrice;
      }, 0.0);
      var total = modifiersTotal + variationPrice;
      return total;
    }
  }, {
    key: "calculateTotal",
    value: function calculateTotal() {
      var _this2 = this;

      var cart = this.props.cart;
      var items = cart.items;
      return items.reduce(function (total, item) {
        return total + _this2.calculateItemTotal(item) * item.quantity;
      }, 0.0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          cart = _this$props.cart,
          menu = _this$props.menu,
          onCheckout = _this$props.onCheckout,
          locationId = _this$props.locationId;
      var isOpen = cart.isOpen;
      var mobileCartOpen = this.state.mobileCartOpen;
      var items = cart.items,
          removeItem = cart.removeItem;
      var modifierSets = menu.modifierSets,
          modifiers = menu.modifiers;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-cart-display"
      }, /*#__PURE__*/_react["default"].createElement(_MenuCartDisplayBanner["default"], {
        mobileCartOpen: mobileCartOpen,
        onToggleMobileCart: this.toggleMobileCart,
        numberOfItems: items.length
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-cart-items ".concat(mobileCartOpen ? 'open' : 'closed')
      }, items.length > 0 ? items.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(_MenuCartDisplayItem["default"], {
          cart: cart,
          key: item.id,
          item: item,
          onRemoveItem: function onRemoveItem() {
            return removeItem(index);
          },
          totalPrice: _this3.calculateItemTotal(item),
          allModifierSets: modifierSets,
          allModifiers: modifiers
        });
      }) : isOpen ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "no-items"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        size: "huge",
        name: "shopping basket"
      }), /*#__PURE__*/_react["default"].createElement("p", null, "Add at least 1 item to your cart to checkout")) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "no-items"
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: _closed["default"],
        style: {
          height: '96px'
        }
      }), /*#__PURE__*/_react["default"].createElement("p", null, "We are closed right now. Please come back later."))), /*#__PURE__*/_react["default"].createElement(_MenuCartDisplayTotal["default"], {
        isOpen: isOpen,
        onCheckout: onCheckout,
        total: this.calculateTotal(),
        cart: cart,
        locationId: locationId
      }));
    }
  }]);
  return MenuCartDisplay;
}(_react["default"].Component);

exports["default"] = MenuCartDisplay;
MenuCartDisplay.propTypes = {
  hours: _propTypes["default"].object,
  onCheckout: _propTypes["default"].func,
  locationId: _propTypes["default"].number.isRequired,
  cart: _propTypes["default"].shape({
    items: _propTypes["default"].array,
    addItem: _propTypes["default"].func,
    removeItem: _propTypes["default"].func,
    updateItem: _propTypes["default"].func,
    containsItem: _propTypes["default"].func,
    clearCart: _propTypes["default"].func,
    getItemIndex: _propTypes["default"].func
  }),
  menu: _propTypes["default"].shape({
    schedules: _propTypes["default"].array,
    categories: _propTypes["default"].array,
    items: _propTypes["default"].array,
    modifierSets: _propTypes["default"].array,
    modifiers: _propTypes["default"].array
  }).isRequired
};